import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '@redux/RootReducer';
import { useQuery } from '@tanstack/react-query';

import * as contractStatusesService from '../services/contract-statuses.service';

export const useContractStatuses = () => {
  const [search, setSearch] = useState('');
  const companyId = useSelector((state: RootState) => String(state.auth.selectedCompany?.companyId ?? ''));

  const { data, isLoading, isError } = useQuery(
    contractStatusesService.contractStatusesQueryOptions({ companyId }, { enabled: Boolean(companyId) }),
  );

  const filteredList = useMemo(() => {
    const list = data?.list ?? [];
    if (!search) {
      return list;
    }

    const lowerSearch = search.toLowerCase();
    return list.filter((item) => item.label.toLowerCase().includes(lowerSearch));
  }, [data?.list, search]);

  return {
    data: {
      list: filteredList,
      map: data?.map ?? {},
    },
    isError,
    isLoading,
    setSearch,
  };
};
